import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	getFiscalYearList as getFiscalYearListApi,
	getFiscalYearById as getFiscalYearByIdApi,
	addFiscalYearWithPeriods as addFiscalYearWithPeriodsApi,
	updateFiscalYear as updateFiscalYearApi,
	deleteFiscalYear as deleteFiscalYearApi,
	getFiscalYearQuery as getFiscalYearQueryApi,
} from '../../helpers/fiscal_year/backend_helper';

export const getFiscalYearList = createAsyncThunk(
	'fiscalYear/getFiscalYearList',
	async params => {
		try {
			const response = getFiscalYearListApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getFiscalYearQuery = createAsyncThunk(
	'fiscalYear/getFiscalYearQuery',
	async params => {
		try {
			const response = await getFiscalYearQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getFiscalYearById = createAsyncThunk(
	'fiscalYear/getFiscalYearById',
	async id => {
		try {
			const response = getFiscalYearByIdApi(id);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const addFiscalYearWithPeriods = createAsyncThunk(
	'fiscalYear/addFiscalYearWithPeriods',
	async fiscalYear => {
		try {
			const response = addFiscalYearWithPeriodsApi(fiscalYear);
			toast.success('Año fiscal agregado exitosamente.', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			toast.error('Error al agregar el año fiscal.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const updateFiscalYear = createAsyncThunk(
	'fiscalYear/updateFiscalYear',
	async fiscalYear => {
		try {
			const response = updateFiscalYearApi(fiscalYear);
			toast.success('Año fiscal actualizado exitosamente', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			toast.error('Error al actualizar el año fiscal.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteFiscalYear = createAsyncThunk(
	'fiscalYear/deleteFiscalYear',
	async fiscalYear => {
		try {
			const response = await deleteFiscalYearApi(fiscalYear);
			toast.success('Año fiscal eliminado exitosamente.', {
				autoClose: 3000,
			});
			return { fiscalYear, ...response };
		} catch (error) {
			toast.error('Error al eliminar el año fiscal.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);
